import neoSwitch from "@shared/components/toggle-switch";
import Loader from "@shared/components/loader";

export default {
    components: {
        neoSwitch,
        "neo-loader": Loader,
    },
    props: {
        showHistory: {
            type: Boolean,
            default: false,
        },
        result: {
            type: Object,
            default: null,
        },
        isOldVersion: {
            type: Boolean,
            default: false,
        },
        isLastVersion: {
            type: Boolean,
            default: false,
        },
        visible: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        async showMonitoringHistory() {
            this.$emit("showMonitoringHistory");
        },
    },
    computed: {
        isMonitoringTab() {
            return this.$route.name === "monitoring";
        },
        getSourceTreeHeight() {
            if (this.isOldVersion) {
                if (this.isLastVersion) return "height: 100%";
                else return "height: calc(100% + 16px)";
            } else return "height: calc(100% - 20px)";
        },
        countMoreThenOneDigit() {
            return this.result?.api_all_data?.history_count > 9;
        }
    },
};
